import { render, staticRenderFns } from "./MoreDetailsDrayage.vue?vue&type=template&id=207b584c&scoped=true"
import script from "./MoreDetailsDrayage.vue?vue&type=script&lang=js"
export * from "./MoreDetailsDrayage.vue?vue&type=script&lang=js"
import style0 from "./MoreDetailsDrayage.vue?vue&type=style&index=0&id=207b584c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b584c",
  null
  
)

export default component.exports